import { ROOT } from "../constants/route.constant";

const appConfig = {
  // authenticatedEntryPath: ROOT,
  unAuthenticatedEntryPath: "/",
  enableMock: true,
};

export default appConfig;
